import React from 'react';
import '../App.css';
import $ from 'jquery';
import config from '.././config.json';
import GradeStudent from './GradeStudent';
import moment from 'moment';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

import { Table, Input, Button, Icon, Badge, Popconfirm, notification } from 'antd';

function JSONToCSVConvertor(JSONData, fileName, ShowLabel, mimeType) {
        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;

    var CSV = '';
    //Set Report title in first row or line

    CSV += fileName + '\r\n\n';

    //This condition will generate the Label/Header
    if (ShowLabel) {
        var row = "";

        //This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {

            //Now convert each value to string and comma-seprated
            row += index + ',';
        }

        row = row.slice(0, -1);

        //append Label row with line break
        CSV += row + '\r\n';
    }

    //1st loop is to extract each row
    for (var i = 0; i < arrData.length; i++) {
        var row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
            row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
    }

    if (CSV == '') {
        alert("Invalid data");
        return;
    }
    fileName = fileName + '.csv';

    var a = document.createElement('a');
    mimeType = mimeType || 'application/octet-stream';

    if (navigator.msSaveBlob) { // IE10
        navigator.msSaveBlob(new Blob([CSV], {
            type: mimeType
        }), fileName);
    } else if (URL && 'download' in a) { //html5 A[download]
        a.href = URL.createObjectURL(new Blob([CSV], {
            type: mimeType
        }));
        a.setAttribute('download', fileName);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } else {
        window.location.href = 'data:application/octet-stream,' + encodeURIComponent(CSV); // only this mime type is supported
    }

}




class StudentPayment extends React.Component {

    state = {
        classData: [],
        updateData: {},
        login: true,
        sortedInfo: null,
    };

    refresh() {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/classes/getall`
        })
            .done((data) => {
                
                this.setState({
                    classData: data
                })
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.error('failed to get data');
            });
    }

    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => { this.refresh(); }); //login
    }

    gradeClass(record) {
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getstudentpayment/` + record.Id
        })
            .done((data) => {
                this.recordClass = record;
                this.classNameSelected = record.Name;
                this.setState({
                    classData: data,
                    classId: record.Id,
                    classSelected: true,
                })
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.error('failed to get data');
            });
    }

    markPaid = (record) => {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/markstudentpaid/` + this.state.classId + '/' + record.StudentId + '/' + record.Paid
        })
            .done((data) => {
                this.gradeClass(this.recordClass);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.error('failed to get data');
            });
 
    }

    handleChangeSort = (pagination, filters, sorter) => {
        this.setState({
            sortedInfo: sorter,
        });
    }

    compareByChar(a, b) { if (a > b) { return -1; } if (a < b) { return 1; } return 0; }



    render() {
        const { loading } = this.state;
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};
        const studentsColumns = [
            {
                title: 'First Name',
                dataIndex: 'FirstName',
                sorter: (a, b) => this.compareByChar(a.FirstName, b.FirstName),
                sortOrder: sortedInfo.columnKey === 'FirstName' && sortedInfo.order
            },
            {
                title: 'Last Name',
                dataIndex: 'LastName',
                sorter: (a, b) => this.compareByChar(a.LastName, b.LastName),
                sortOrder: sortedInfo.columnKey === 'LastName' && sortedInfo.order,
            },
            {
                title: 'Tech ID',
                dataIndex: 'TechID',
                sorter: (a, b) => a.TechID - b.TechID,
                sortOrder: sortedInfo.columnKey === 'TechID' && sortedInfo.order,
            },
            {
                title: 'Email',
                dataIndex: 'Email',
            },
            {
                title: 'Attendance',
                dataIndex: 'AttendanceSelection' 
            },
            {
                title: 'Payment',
                dataIndex: 'Paid',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            {record.Paid !== 1 && <span><Badge status="error" />Not Paid</span>}
                            {record.Paid == 1 && <span><Badge status="success" />Paid</span>}
                        </div>
                    );
                },
                sorter: (a, b) => this.compareByChar(a.Paid, b.Paid),
                sortOrder: sortedInfo.columnKey === 'Paid' && sortedInfo.order

            },

            {
                title: 'Action',
                dataIndex: 'grade',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => { this.markPaid(record) }}>Paid/Unpaid</a>
                            </span>
                        </div>
                    );
                }
            }
        ];

        const classColumns = [
            {
                title: 'Class',
                dataIndex: 'Name',
                key: 'Name',
                sorter: (a, b) => this.compareByChar(a.Name, b.Name),
                sortOrder: sortedInfo.columnKey === 'Name' && sortedInfo.order

            },

            {
                title: 'Start Date',
                dataIndex: 'StartDate',
                render: (text, record, index) => {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
                sorter: (a, b) => this.compareByChar(a.StartDate, b.StartDate),
                sortOrder: sortedInfo.columnKey === 'StartDate' && sortedInfo.order,
            },
            {
                title: 'End Date',
                dataIndex: 'EndDate',
                render: (text, record, index) => {
                    return (
                        <span>
                            {moment(text).format('l')}
                        </span>
                    );
                },
            },
            {
                title: 'Cost',
                dataIndex: 'Cost',
            },
            {
                title: 'Action',
                dataIndex: 'edit',
                render: (text, record, index) => {
                    return (
                        <div className="editable-row-operations">
                            <span>
                                <a onClick={() => this.gradeClass(record)}>Students</a>
                            </span>
                        </div>
                    );
                }
            }
        ];

        // render stuff.. finally...
        return (
            <div>
                {this.state.login ?
                <div>
                    {!this.state.classSelected &&
                        <div>
                            <h2>Payment Manager</h2>
                            <hr />
                            <Table rowKey="Id" bordered columns={classColumns}
                                dataSource={this.state.classData}
                                onChange={this.handleChangeSort}
                                pagination={{ pageSize: 30 }}
                            />
                        </div>
                    }
                    {this.state.classSelected &&
                        <div>
                            <h2>Payment Status: {this.classNameSelected}</h2>
                            <hr />
                            <Table rowKey="StudentId" bordered columns={studentsColumns}
                                dataSource={this.state.classData}
                                onChange={this.handleChangeSort}
                                pagination={{ pageSize: 30 }}
                            />
                            <button onClick={() => { this.setState({ classSelected: false }); this.refresh() }} style={{ margin: 5, float: 'left' }} className="btn btn-default" >Back</button>
                            <button onClick={() => { this.getExcel() }} style={{ margin: 5, float: 'right' }}  className="btn btn-default" >Export to Excel</button>
                        </div>
                    }
                </div>
            : <Redirect to="/login" replace />
            }
            </div>
        );
    }

    getExcel = () => {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getexcelexport/` + this.state.classId
        })
            .done((data) => {
                this.excelData = data;
                JSONToCSVConvertor(this.excelData, this.classNameSelected, true, 'text/csv;encoding:utf-8');
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('failed to get data');
            });


    }
}


export default StudentPayment;


// WEBPACK FOOTER //
// ./src/Admin/StudentPayment.js